"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PEPFilter = require("./PEPFilter");

var _PEPGuideConfig = _interopRequireDefault(require("./PEPGuideConfig"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PEPConfig = /*#__PURE__*/function () {
  /**
   * Holds the parsed config for a PEPComponent from Sitecore
   * @param {object} config
   * @param {PIMConfig} config.pim An object of endpoints to configure a PIM instance
   * @param {object} config.filters A list for filters for the component
   * @param {Object} config.guide The configuration for a PEPGuide
   * @constructor
   */
  function PEPConfig(config) {
    _classCallCheck(this, PEPConfig);

    var dataSource = config.Configuration || config.configuration || config;
    /**
     * @type {object}
     */

    this.data = config.Data || config.data;
    /**
     * An object of endpoints to configure a PIM instance
     * @type {PIMConfig}
     */

    this.pim = dataSource.PIM || dataSource.pim || {};
    /**
     * A list for filters for the component
     * @type {PEPFilter[]}
     */

    this.filters = function (filtersData) {
      var filters = [];

      if (filtersData && Array.isArray(filtersData)) {
        filtersData.forEach(function (filterData) {
          filters.push(new _PEPFilter.PEPFilter(filterData));
        });
      }

      return filters;
    }(dataSource.Filters || dataSource.filters);
    /**
     * The configuration for a PEPGuide
     * @type {PEPGuideConfig}
     */


    this.guide = dataSource.Guide || dataSource.guide ? new _PEPGuideConfig["default"](dataSource.Guide || dataSource.guide) : new _PEPGuideConfig["default"](dataSource);
  }
  /**
   * Returns filters target at hearing instruments or are global
   * @returns {PEPFilter[]};
   */


  _createClass(PEPConfig, [{
    key: "getHearingInstrumentFilters",
    value: function getHearingInstrumentFilters() {
      return this.filters.filter(function (filter) {
        return filter.filterTarget === _PEPFilter.PEPFILTER_TARGET.HI || filter.filterTarget === _PEPFilter.PEPFILTER_TARGET.GLOBAL;
      });
    }
    /**
     * Returns filters target at accessories or are global
     * @returns {PEPFilter[]};
     */

  }, {
    key: "getAccessoriesFilters",
    value: function getAccessoriesFilters() {
      return this.filters.filter(function (filter) {
        return filter.filterTarget === _PEPFilter.PEPFILTER_TARGET.ACC || filter.filterTarget === _PEPFilter.PEPFILTER_TARGET.GLOBAL;
      });
    }
    /**
     * Returns all filters regardless of target
     * @returns {PEPFilter[]};
     */

  }, {
    key: "getAllFilters",
    value: function getAllFilters() {
      return this.filters;
    }
  }]);

  return PEPConfig;
}();

var _default = PEPConfig;
exports["default"] = _default;